var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChecked(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "",
    enableBackground: "new 0 0 512 512",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m416 512h-320c-53.023 0-96-42.977-96-96v-320c0-53.023 42.977-96 96-96h320c53.023 0 96 42.977 96 96v320c0 53.023-42.977 96-96 96z",
    fill: "#a1d4e2",
    style: {},
    "data-original": "#fff9dd",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m281.3 313.3c-6.0508 6.0469-14.082 9.375-22.625 9.375s-16.574-3.3281-22.625-9.375l-45.328-45.328c-6.0469-6.0469-9.375-14.082-9.375-22.625s3.3281-16.574 9.375-22.625c6.0508-6.0469 14.082-9.375 22.625-9.375s16.578 3.3281 22.625 9.375l22.703 22.707 62.688-62.691c-20.48-17.453-46.992-28.062-76.031-28.062-64.801 0-117.33 52.527-117.33 117.33s52.527 117.33 117.33 117.33 117.34-52.527 117.34-117.33c0-12.129-1.8398-23.824-5.2656-34.832z",
    fill: "#2a93d4",
    style: {},
    "data-original": "#ffd200",
    xmlns: "http://www.w3.org/2000/svg"
  }), /*#__PURE__*/React.createElement("path", {
    className: "",
    d: "m258.67 301.33c-2.7344 0-5.457-1.0391-7.5352-3.1211l-45.328-45.328c-4.1602-4.1602-4.1602-10.91 0-15.086s10.91-4.1602 15.086 0l37.793 37.793 107.12-107.12c4.1602-4.1602 10.91-4.1602 15.086 0s4.1602 10.91 0 15.086l-114.67 114.67c-2.0938 2.0664-4.832 3.1055-7.5508 3.1055z",
    fill: "#00416d",
    style: {},
    "data-original": "#ffe777",
    xmlns: "http://www.w3.org/2000/svg"
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChecked);
export default __webpack_public_path__ + "static/media/checked.13aeaf41.svg";
export { ForwardRef as ReactComponent };